module.exports = __webpack_public_path__ + "static/media/ic_file_download_24px.14fe5e93.svg";